import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { Grid, GridItem, Skeleton } from '@chakra-ui/react';

export const SoundCloudVersionFormLoader = () => (
  <ContentContainer
    type={ContentContainerType.LIST}
    pb={24}
    data-testid="soundcloud-version-details-loader"
  >
    <Grid
      templateColumns="repeat(4, 1fr)"
      columnGap={4}
      w="full"
      maxW="640px"
      mx="auto"
    >
      <GridItem colSpan={{ base: 4 }} h="70px">
        <Skeleton w="full" h="48px" />
      </GridItem>
    </Grid>
  </ContentContainer>
);
